import * as React from 'react';
import Tabs from '@roo/roo/Tabs';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import UserBar from './components/UserBar';
import BalanceList from './components/BalanceList';
import BillList from './components/BillList';
import DownloadBalance from './components/DownloadBalance';
import InvoiceLink from './components/InvoiceLink';

import './index.scss';

const { Pane: TabPane } = Tabs;
const { useState, useEffect } = React;

function IndexSettlementTP(props: RouteComponentProps) {
    const { history } = props;
    const [activeTab, setActiveTab] = useState<string>('');

    useEffect(() => {
        const { location } = props;
        const childPath = location.pathname.split('/')[2];
        setActiveTab(childPath);
    }, [props.history.location]);

    function gotoTab(name: string) {
        history.push(`/settlementTP/${name}`);
        setActiveTab(name);
    }

    return (
        <div className="page settlement-tp">
            <UserBar />
            <div className="main-ct">
                <Tabs type="fill" value={activeTab} onTabClick={gotoTab} reRender>
                    <TabPane label="余额流水" name="balance">
                        <BalanceList />
                    </TabPane>
                    <TabPane label="账单" name="bill">
                        <BillList />
                    </TabPane>
                    <TabPane label="下载流水明细" name="download">
                        <DownloadBalance />
                    </TabPane>
                </Tabs>
                <InvoiceLink />
            </div>
        </div>
    );
}

export default withRouter(IndexSettlementTP);
